export default __webpack_public_path__ + "static/media/shakinghands2.5b8bc6b5.jpg";